import React, { useMemo } from "react";
import Button from "../../atoms/Button";
import { PropagateLoader } from "react-spinners";
import InputField from "../../atoms/InputField";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { REGISTER_USER_RS } from "../../../api/apiAdmin";
import Select from "react-select";

const ModalCreateUsuarioRS = ({ onClose, refetch, usuarios = [] }) =>{
    const nextNode = useMemo(() => {
        if (!usuarios || usuarios.length === 0) return 1;
        const maxNode = Math.max(...usuarios.map((u) => u.actualNode || 0));
        return maxNode + 1;
    }, [usuarios]);

    const parentOptions = useMemo(() => {
        return usuarios.map((u) => ({
            value: u.actualNode,
            label: `${u.name} (Nodo: ${u.actualNode})`,
        }));
    }, [usuarios]);

    const validate = (values) => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!values.name) { errors.name = "El nombre es requerido"; }
        if (!values.email) { errors.email = "El email es requerido"; } 
            else if (!emailRegex.test(values.email)) { errors.email = "El email no es válido"; }
        if (!values.position) { errors.position = "La posición es requerida"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const upperCaseValues = {
                ...values,
                name: values.name.toUpperCase(),
                actualNode: nextNode,
            };
            await REGISTER_USER_RS(upperCaseValues);
            toast.success("Registro exitoso");
            refetch();
            onClose();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = { name: "", email: "", cellphone: "", position: "", parentNode: "" }

    return(
        <div>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validate} >
                {({ isSubmitting, setFieldValue, values }) => (
                    <Form className="w-full flex flex-col items-center justify-center text-center space-y-4">
                        <InputField name="name" label="Nombre completo" placeholder="Nombre completo" capitalize />
                        <InputField name="email" label="Correo electrónico" placeholder="CORREO ELECTRÓNICO" />
                        <InputField name="cellphone" label="Numero de telefono" placeholder="NÚmero de telÉfono" capitalize type="number" />
                        <InputField name="position" label="Posición / Cargo" placeholder="Posición o cargo" capitalize />
                        <div className="w-full text-left">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                JEFE DIRECTO
                            </label>
                            <Select
                                name="parentNode"
                                options={parentOptions}
                                className="basic-select border border-black rounded-lg"
                                classNamePrefix="select"
                                placeholder="Seleccionar jefe directo..."
                                isClearable
                                onChange={(selectedOption) =>
                                    setFieldValue("parentNode", selectedOption ? selectedOption.value : "")
                                }
                                value={parentOptions.find((opt) => opt.value === values.parentNode) || null}
                            />
                        </div>
                        <div className="w-full text-left">
                            <label className="block text-sm font-medium text-gray-500">
                                Nodo asignado: <span className="font-bold text-black">{nextNode}</span>
                            </label>
                        </div>
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Registrar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                    </Form>
                )}
            </Formik>
        </div>
    )
};

export default ModalCreateUsuarioRS;